import React from 'react';

/**
 * Hover tooltip carrying the raw stored string an edge was derived from
 * (`checkpoint:idea`, `param:tone`, a connector's implicit source, …). The
 * canvas otherwise shows only the SHAPE of a wire, never its text.
 *
 * Implemented as an invisible fat overlay path with an SVG <title>: BaseEdge
 * takes no children, and a native title needs no hover state, no portal and no
 * repositioning as the user pans or zooms.
 */
const EdgeDslTooltip: React.FC<{ edgeId: string; path: string; dsl?: string }> = ({
  edgeId,
  path,
  dsl,
}) => {
  if (!dsl) return null;
  return (
    <path
      d={path}
      fill="none"
      stroke="transparent"
      strokeWidth={16}
      className="react-flow__edge-interaction"
      data-testid={`canvas-edge-tooltip-${edgeId}`}
    >
      <title>{dsl}</title>
    </path>
  );
};

/** Narrows React Flow's `unknown`-valued edge data to the DSL string, if any. */
export const edgeDsl = (data?: Record<string, unknown>): string | undefined =>
  typeof data?.dsl === 'string' && data.dsl ? data.dsl : undefined;

export default EdgeDslTooltip;
